module.exports = __webpack_public_path__ + "static/Particulator-bd08dd9355ba74b1353f75be448b1962.jpg";